import React, { useState, useEffect } from "react";
import CardVale from "./cardvale";
import { Box, Checkbox } from "@mui/material";

interface ValeComprasProps {
  onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ValeCompras: React.FC<ValeComprasProps> = ({ onCheckboxChange }) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onCheckboxChange(event);
  };

  return (
    <Box marginY={2}>
      <CardVale />
      <Box mt={4}>
        <p style={{ textAlign: "center" }}>
          O seu <strong>Vale Compras</strong> será enviado diretamente para o e-mail cadastrado na Fut.
        </p>
      </Box>
      <Box display={"flex"} flexDirection={"row"} alignItems={"center"} justifyContent={"center"} marginTop={2}>
        <Checkbox onChange={handleCheckboxChange} color="error" />
        <p>
          Ao continuar, você declara que está de acordo com os termos da&nbsp;
          <a href="https://www.kappa.com.br/politica-de-privacidade/" target="_blank" style={{ color: "#000" }}>
            lei de LGPD
          </a>
        </p>
      </Box>
    </Box>
  );
};

export default ValeCompras;
